import {CreatePlan, CreatePlanSummary} from "../view-model";

export const summarizePlan = (plan: CreatePlan): CreatePlanSummary => {
  return {
    creating: 1,
    mapped: plan.source.mappedOperationalEntities ?? []
  };
};
